export default __webpack_public_path__ + "static/media/Image-6.2a0d9490.png";